enum EFieldName {
  DESCRIPTION = 'description',
  IMAGE = 'image',
}

export default EFieldName;
